import { AntDesign } from '@expo/vector-icons'

export const Icon = AntDesign

export type IconName = keyof typeof AntDesign.glyphMap

// see: https://icons.expo.fyi/Index
